import Vue from 'vue'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_506fe8c2 from 'nuxt_plugin_plugin_506fe8c2' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_nuxtuseragent_45b360ce from 'nuxt_plugin_nuxtuseragent_45b360ce' // Source: ./nuxt-user-agent.js (mode: 'all')
import nuxt_plugin_axios_35adc845 from 'nuxt_plugin_axios_35adc845' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_base_5a09ad60 from 'nuxt_plugin_base_5a09ad60' // Source: ../plugins/base.js (mode: 'all')
import nuxt_plugin_chartist_94bdd556 from 'nuxt_plugin_chartist_94bdd556' // Source: ../plugins/chartist.js (mode: 'all')
import nuxt_plugin_ui_33425da6 from 'nuxt_plugin_ui_33425da6' // Source: ../plugins/ui.js (mode: 'all')
import nuxt_plugin_assets_83774644 from 'nuxt_plugin_assets_83774644' // Source: ../plugins/assets.js (mode: 'all')
import nuxt_plugin_api_785206da from 'nuxt_plugin_api_785206da' // Source: ../plugins/api.js (mode: 'all')
import nuxt_plugin_pages_265ec929 from 'nuxt_plugin_pages_265ec929' // Source: ../plugins/pages.js (mode: 'all')
import nuxt_plugin_users_397b5736 from 'nuxt_plugin_users_397b5736' // Source: ../plugins/users.js (mode: 'all')
import nuxt_plugin_browsers_da12d2d4 from 'nuxt_plugin_browsers_da12d2d4' // Source: ../plugins/browsers.js (mode: 'all')
import nuxt_plugin_components_50cb0b6b from 'nuxt_plugin_components_50cb0b6b' // Source: ../plugins/components.js (mode: 'all')
import nuxt_plugin_downloader_257e5a28 from 'nuxt_plugin_downloader_257e5a28' // Source: ../plugins/downloader.js (mode: 'all')
import nuxt_plugin_alert_535fa891 from 'nuxt_plugin_alert_535fa891' // Source: ../plugins/alert.js (mode: 'all')
import nuxt_plugin_maintenance_7a7f420c from 'nuxt_plugin_maintenance_7a7f420c' // Source: ../plugins/maintenance.js (mode: 'all')
import nuxt_plugin_axios_5659d192 from 'nuxt_plugin_axios_5659d192' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_userConnectionStatusList_b34d9170 from 'nuxt_plugin_userConnectionStatusList_b34d9170' // Source: ../plugins/constants/userConnectionStatusList.js (mode: 'all')
import nuxt_plugin_notificationCategoryList_2d95024c from 'nuxt_plugin_notificationCategoryList_2d95024c' // Source: ../plugins/constants/notificationCategoryList.js (mode: 'all')
import nuxt_plugin_logLevel_5a12fce1 from 'nuxt_plugin_logLevel_5a12fce1' // Source: ../plugins/constants/logLevel.js (mode: 'all')
import nuxt_plugin_tenantType_61dfa37d from 'nuxt_plugin_tenantType_61dfa37d' // Source: ../plugins/constants/tenantType.js (mode: 'all')
import nuxt_plugin_timeutil_d20ca5c4 from 'nuxt_plugin_timeutil_d20ca5c4' // Source: ../plugins/functions/timeutil.js (mode: 'all')
import nuxt_plugin_hyosec_02bd6a5a from 'nuxt_plugin_hyosec_02bd6a5a' // Source: ../plugins/functions/hyosec.js (mode: 'all')
import nuxt_plugin_validator_4d45324f from 'nuxt_plugin_validator_4d45324f' // Source: ../plugins/functions/validator.js (mode: 'all')
import nuxt_plugin_objutil_2d3b2148 from 'nuxt_plugin_objutil_2d3b2148' // Source: ../plugins/functions/objutil.js (mode: 'all')
import nuxt_plugin_perfectScrollbar_12501d50 from 'nuxt_plugin_perfectScrollbar_12501d50' // Source: ../plugins/libralies/perfectScrollbar.js (mode: 'all')
import nuxt_plugin_server_33607000 from 'nuxt_plugin_server_33607000' // Source: ../plugins/configs/server.js (mode: 'all')
import nuxt_plugin_ckeditor_01e62ccc from 'nuxt_plugin_ckeditor_01e62ccc' // Source: ../plugins/ckeditor.js (mode: 'client')
import nuxt_plugin_plugin_5c8ccdc1 from 'nuxt_plugin_plugin_5c8ccdc1' // Source: ./auth/plugin.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp (ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  const registerModule = store.registerModule
  store.registerModule = (path, rawModule, options) => registerModule.call(store, path, rawModule, Object.assign({ preserveState: process.client }, options))

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"テレワーク兵庫","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"兵庫県在宅支援システム テレワーク兵庫"},{"http-equiv":"X-UA-Compatible","content":"IE=edge"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:300,400,500,700|Material+Icons"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  const inject = function (key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Plugin execution

  if (typeof nuxt_plugin_plugin_506fe8c2 === 'function') {
    await nuxt_plugin_plugin_506fe8c2(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtuseragent_45b360ce === 'function') {
    await nuxt_plugin_nuxtuseragent_45b360ce(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_35adc845 === 'function') {
    await nuxt_plugin_axios_35adc845(app.context, inject)
  }

  if (typeof nuxt_plugin_base_5a09ad60 === 'function') {
    await nuxt_plugin_base_5a09ad60(app.context, inject)
  }

  if (typeof nuxt_plugin_chartist_94bdd556 === 'function') {
    await nuxt_plugin_chartist_94bdd556(app.context, inject)
  }

  if (typeof nuxt_plugin_ui_33425da6 === 'function') {
    await nuxt_plugin_ui_33425da6(app.context, inject)
  }

  if (typeof nuxt_plugin_assets_83774644 === 'function') {
    await nuxt_plugin_assets_83774644(app.context, inject)
  }

  if (typeof nuxt_plugin_api_785206da === 'function') {
    await nuxt_plugin_api_785206da(app.context, inject)
  }

  if (typeof nuxt_plugin_pages_265ec929 === 'function') {
    await nuxt_plugin_pages_265ec929(app.context, inject)
  }

  if (typeof nuxt_plugin_users_397b5736 === 'function') {
    await nuxt_plugin_users_397b5736(app.context, inject)
  }

  if (typeof nuxt_plugin_browsers_da12d2d4 === 'function') {
    await nuxt_plugin_browsers_da12d2d4(app.context, inject)
  }

  if (typeof nuxt_plugin_components_50cb0b6b === 'function') {
    await nuxt_plugin_components_50cb0b6b(app.context, inject)
  }

  if (typeof nuxt_plugin_downloader_257e5a28 === 'function') {
    await nuxt_plugin_downloader_257e5a28(app.context, inject)
  }

  if (typeof nuxt_plugin_alert_535fa891 === 'function') {
    await nuxt_plugin_alert_535fa891(app.context, inject)
  }

  if (typeof nuxt_plugin_maintenance_7a7f420c === 'function') {
    await nuxt_plugin_maintenance_7a7f420c(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659d192 === 'function') {
    await nuxt_plugin_axios_5659d192(app.context, inject)
  }

  if (typeof nuxt_plugin_userConnectionStatusList_b34d9170 === 'function') {
    await nuxt_plugin_userConnectionStatusList_b34d9170(app.context, inject)
  }

  if (typeof nuxt_plugin_notificationCategoryList_2d95024c === 'function') {
    await nuxt_plugin_notificationCategoryList_2d95024c(app.context, inject)
  }

  if (typeof nuxt_plugin_logLevel_5a12fce1 === 'function') {
    await nuxt_plugin_logLevel_5a12fce1(app.context, inject)
  }

  if (typeof nuxt_plugin_tenantType_61dfa37d === 'function') {
    await nuxt_plugin_tenantType_61dfa37d(app.context, inject)
  }

  if (typeof nuxt_plugin_timeutil_d20ca5c4 === 'function') {
    await nuxt_plugin_timeutil_d20ca5c4(app.context, inject)
  }

  if (typeof nuxt_plugin_hyosec_02bd6a5a === 'function') {
    await nuxt_plugin_hyosec_02bd6a5a(app.context, inject)
  }

  if (typeof nuxt_plugin_validator_4d45324f === 'function') {
    await nuxt_plugin_validator_4d45324f(app.context, inject)
  }

  if (typeof nuxt_plugin_objutil_2d3b2148 === 'function') {
    await nuxt_plugin_objutil_2d3b2148(app.context, inject)
  }

  if (typeof nuxt_plugin_perfectScrollbar_12501d50 === 'function') {
    await nuxt_plugin_perfectScrollbar_12501d50(app.context, inject)
  }

  if (typeof nuxt_plugin_server_33607000 === 'function') {
    await nuxt_plugin_server_33607000(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_ckeditor_01e62ccc === 'function') {
    await nuxt_plugin_ckeditor_01e62ccc(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_5c8ccdc1 === 'function') {
    await nuxt_plugin_plugin_5c8ccdc1(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
